import { render } from "./excel.vue?vue&type=template&id=a33c7ede&scoped=true"
import script from "./excel.vue?vue&type=script&lang=js"
export * from "./excel.vue?vue&type=script&lang=js"

import "./excel.vue?vue&type=style&index=0&id=a33c7ede&scoped=true&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a33c7ede"]])

export default __exports__